import OrderTemplateItem from '../../components/orders/order-template-item';
import OrderTemplateModals from '../../components/orders/order-template-modals';
import Page from '../page';

export default class OrderTemplateOverviewPage extends Page {

  private readonly orderTemplateModals: OrderTemplateModals;

  constructor(body: JQuery) {
    super();
    this.orderTemplateModals = new OrderTemplateModals(body, true);
    body.find('.js-orderTemplateCard').map((i, element) => (new OrderTemplateItem($(element), this.orderTemplateModals)));
  }
}
